import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { TransferComponent } from './transfer/transfer.component';
import { LoginComponent } from './login/login.component';
import { TxhistoryComponent } from './txhistory/txhistory.component';
import { CreatewalletComponent } from './createwallet/createwallet.component'
import { ExportComponent } from './export/export.component';
import { ImportComponent } from './import/import.component';
import { ReceiveComponent } from './receive/receive.component'

const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'login', component: LoginComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'transfer', component: TransferComponent },
	{ path: 'txhistory', component: TxhistoryComponent },
	{ path: 'createwallet', component: CreatewalletComponent },
	{ path: 'import', component: ImportComponent },
	{ path: 'export', component: ExportComponent },
	{ path: 'receive', component: ReceiveComponent }

];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
